import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sourcesList", "trixEditor", "bodyInput", "messageFormatInput"]

  static values = { recipient: String }

  connect() {
    App.popover(".trix-toolbar-button[data-bs-toggle='popover']")
  }

  draft() {
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 10000) // 10 second timeout

    fetch("/messages/drafts", {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: this.#messageJson(),
      signal: controller.signal,
    })
      .then(async (response) => {
        clearTimeout(timeoutId)
        let errorMessage = i18n.t("js.back.messages.drafts.errors.draft_failed")

        if (!response.ok) {
          errorMessage = this.getErrorMessage(response.status)
          throw new Error(errorMessage)
        }

        return response.json()
      })
      .then((response) => {
        // For message in text format we need to ensure we use the stripped version
        if (response.message.message_format == "text") {
          this.trixEditorTarget.editor.loadHTML(response.message.body)
        }
      })
      .catch((error) => {
        clearTimeout(timeoutId)

        if (error.name === "AbortError") {
          App.displayFlash("danger", i18n.t("js.back.messages.drafts.errors.timeout"))
        } else if (error.name === "SyntaxError") {
          App.displayFlash("danger", i18n.t("js.back.messages.drafts.errors.draft_failed"))
        } else {
          App.displayFlash("danger", error.message || i18n.t("js.back.messages.drafts.errors.unexpected_error"))
        }
      })
  }

  send(e) {
    if ($(e.target).hasClass("disabled")) {
      console.info("Your email is being sent...")
      return
    }

    $(e.target).addClass("disabled")

    fetch("/messages", {
      method: "POST",
      credentials: "same-origin",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      }),
      body: this.#messageJson(),
    })
      .then((response) => response.json())
      .then((object) => {
        $(e.target).removeClass("disabled")

        if (object.error != undefined) {
          let message = ""

          if (!object.rate_limit) {
            message = "Error: "
          }

          message += object.error

          $("#compose-modal .error-message").show().html(`<span>${message}</span>`)
          return
        }

        App.modal("#compose-modal", "hide")
        App.displayFlash("success", `Your email to ${this.recipientValue} is on its way.`)
        App.analytics.ga_track("Email", "Send")
      })
      .catch((error) => {
        $(e.target).removeClass("disabled")

        $("#compose-modal .error-message")
          .show()
          .html("Your email couldn't be created. Please retry and contact us if the problem persists.")

        console.error(`Failed to create the email: ${error}`)
      })
  }

  templateSelected() {
    var template = $("select#template-field").find(":selected")
    $("#subject-field").val(template.data("subject"))
    this.trixEditorTarget.editor.loadHTML(template.data("body"))

    // Apply the message_format from the template
    if (this.hasMessageFormatInputTarget && template.data("message-format")) {
      this.messageFormatInputTarget.value = template.data("message-format")

      // Toggle HTML mode in trix-editor based on message_format
      const trixEditorElement = this.element.querySelector('[data-controller~="trix-editor"]')
      if (trixEditorElement) {
        const trixEditorController = this.application.getControllerForElementAndIdentifier(
          trixEditorElement,
          "trix-editor",
        )

        if (trixEditorController) {
          if (template.data("message-format") === "html") {
            trixEditorController.enableHtml()
          } else if (template.data("message-format") === "text") {
            trixEditorController.disableHtml(true)
          }
        }
      }
    }
  }

  toggleSources(e) {
    $(e.target).find(".far").toggleClass("fa-angle-up").toggleClass("fa-angle-down")
    $(this.sourcesListTarget).slideToggle(200)
  }

  getErrorMessage(status) {
    switch (status) {
      case 422:
        return i18n.t("js.back.messages.drafts.errors.validation_error")
      case 401:
        return i18n.t("js.back.messages.drafts.errors.session_expired")
      case 403:
        return i18n.t("js.back.messages.drafts.errors.permission_denied")
      case 500:
        return i18n.t("js.back.messages.drafts.errors.server_error")
      default:
        return i18n.t("js.back.messages.drafts.errors.draft_failed")
    }
  }

  #messageJson() {
    return JSON.stringify({
      message: {
        message_format: this.hasMessageFormatInputTarget ? this.messageFormatInputTarget.value : "html",
        to: this.recipientValue,
        subject: $("input#subject-field").val(),
        body: $("input#body-field").val(),
        add_unsubscribe_link: $("input#message_add_unsubscribe_link").is(":checked"),
        email_account_id: $("#email-account-field").val(),
        tracked: $("input#tracked-field").is(":checked"),
      },
    })
  }
}
